import axios from 'axios';

export const httpJump = axios.create({
  baseURL: 'https://storerobots.gamechanger.kz',
  headers: { 'Content-Type': 'application/json' },
  withCredentials: false,
});
